export default {"src":"/_next/static/media/social-security.37406df9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};